var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotConnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ff0000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    stroke: "#ff0000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M65.206,36.688c-0.781-0.781-2.047-0.781-2.828,0l-9.899,9.899l-9.9-9.899c-0.781-0.781-2.047-0.781-2.828,0 c-0.781,0.781-0.781,2.047,0,2.828l9.9,9.899l-9.9,9.899c-0.781,0.781-0.781,2.047,0,2.828c0.391,0.391,0.902,0.586,1.414,0.586 s1.023-0.195,1.414-0.586l9.9-9.899l9.899,9.899c0.391,0.391,0.902,0.586,1.414,0.586s1.023-0.195,1.414-0.586 c0.781-0.781,0.781-2.047,0-2.828l-9.899-9.899l9.899-9.899C65.987,38.735,65.987,37.468,65.206,36.688z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.18,25.8C69.861,19.481,61.459,16,52.522,16S35.185,19.48,28.865,25.8c-13.045,13.045-13.045,34.271,0,47.315 c6.318,6.319,14.721,9.8,23.657,9.8c8.938,0,17.34-3.48,23.659-9.8c6.319-6.318,9.799-14.721,9.799-23.658 C85.979,40.521,82.499,32.119,76.18,25.8z M73.354,70.287c-5.564,5.563-12.962,8.628-20.831,8.628 c-7.868,0-15.266-3.064-20.829-8.628c-11.485-11.485-11.485-30.174,0-41.659C37.258,23.064,44.654,20,52.522,20 s15.266,3.064,20.829,8.627s8.628,12.961,8.629,20.83C81.98,57.326,78.917,64.724,73.354,70.287z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotConnected);
export default __webpack_public_path__ + "static/media/not-connected.cb0af1ef52bcb53673c6153e91037a4e.svg";
export { ForwardRef as ReactComponent };